import { RESPONDENT_STATUS_CODE } from './respondent-status.constants';

export interface RespondentStatusOption {
  value: number;
  label: string;
}

export const RESPONDENT_STATUS_OPTIONS: RespondentStatusOption[] = [
  {
    value: RESPONDENT_STATUS_CODE.PS_SIDE_IN_PROGRESS,
    label: 'PS Side In Progress (14)',
  },
  {
    value: RESPONDENT_STATUS_CODE.BUYER_SIDE_IN_PROGRESS,
    label: 'Buyer side In Progress (16)',
  },
  {
    value: RESPONDENT_STATUS_CODE.BUYER_QUALITY_TERMINATION,
    label: 'Buyer Quality Termination (20)',
  },
  { value: RESPONDENT_STATUS_CODE.COMPLETE, label: 'Complete (21)' },
  {
    value: RESPONDENT_STATUS_CODE.PS_LOI_THRESHOLD_FAILURE,
    label: 'PS LOI Threshold Failure (29)',
  },
  {
    value: RESPONDENT_STATUS_CODE.BUYER_SECURITY,
    label: 'Buyer Security (30)',
  },
  {
    value: RESPONDENT_STATUS_CODE.PS_PSID_GEO_TERMINATION,
    label: 'PS PSID Geo Termination (38)',
  },
  {
    value: RESPONDENT_STATUS_CODE.BUYER_PS_API_FAIL,
    label: 'Buyer PS API Fail (84)',
  },
  {
    value: RESPONDENT_STATUS_CODE.BUYER_QUOTA_FULL,
    label: 'Buyer Quota Full (17)',
  },
  {
    value: RESPONDENT_STATUS_CODE.BUYER_TERMINATION,
    label: 'Buyer Termination (18)',
  },
  { value: RESPONDENT_STATUS_CODE.BUYER_DROP, label: 'Buyer Drop (19)' },
  {
    value: RESPONDENT_STATUS_CODE.BUYER_HASH_SECURITY,
    label: 'Buyer Hash Security (31)',
  },
  {
    value: RESPONDENT_STATUS_CODE.BUYER_RECONCILIATION_REJECT,
    label: 'Buyer Reconciliation Reject (33)',
  },
];
